import { useContext } from 'react';

import { popupParams } from 'config/Popup/params';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';
import {
    getApiUrl,
    getUrlForLegacyHib,
    HotelDetailType,
} from 'utility/Provide/Url';

import { MapServiceApiInterface } from 'types/legacy/mapService';

import { useLocalStorage } from './useLocalStorage';

const getHashCode = (str: string) => {
    let hash = 0;

    if (!str) {
        return hash;
    }

    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) | 0;
    }

    return hash;
};

export const useHib = () => {
    const { components } = useContext(CommunicationContext);
    const { setItemPhpSessionScope } = useLocalStorage();
    const mapService: MapServiceApiInterface =
        components?.travel?.map?.mapService ?? null;
    const openPopup = (hotelId: number, type: HotelDetailType) => {
        const params = popupParams.hib,
            actualUrlHash = getHashCode(window.location.href);
        let hibUrl = getApiUrl(type, hotelId, getUrlForLegacyHib(), true);

        if (window.name !== params.title) {
            window.name = `${actualUrlHash}`;
            hibUrl += `&oldWindowHash=${actualUrlHash}`;
        }

        const currentMapDataKey = `currentHibMapData${getHashCode(hibUrl)}`;
        const mapData = !!mapService
            ? mapService.getMapMarkerTooltipStorage(hotelId)
            : null;

        setItemPhpSessionScope(currentMapDataKey, mapData);
        hibUrl += `&currentMapDataKey=${currentMapDataKey}`;

        try {
            const windowOpen = window.open(
                hibUrl,
                params.title,
                `width=${params.width},height=${params.height},scrollbars=yes`
            );
            if (!!windowOpen) {
                try {
                    windowOpen.focus();
                } catch (error) {
                    throw new Error(`Error window.open not allowed: ${error}`);
                }
            }
        } catch (error) {
            throw new Error(`Error opening hib popup: ${error}`);
        }
    };

    return { openPopup };
};
